import _ from 'lodash'
import md5 from 'md5'

const DEFAULT_COLUMNS = [
  { key: 'Katalognr', default: '', name: 'Kat.nr', sortKey: 'Objekt__Katalognr', class: 'c-number sorttable_numeric', readonly: true, selected: true },
  { key: 'photo_thumb', default: '', name: 'Bilde', sortKey: '', class: 'c-image unsortable', readonly: true, selected: true },
  { key: 'Objektnr', default: '', name: 'Objektnr', sortKey: 'Objekt__Objektnr', class: 'sorttable_numeric', readonly: true, selected: true },
  { key: 'Kategori', default: '-', name: 'Kat.', sortKey: 'Objekt__Kategori', class: '', selected: true },
  { key: 'kunstner.Navn', default: '-', name: 'Kunstner', sortKey: 'Kunstner__Navn', class: '', selected: true },
  { key: 'Katalogtekst1', default: '-', name: 'Tittel', sortKey: 'Objekt__Katalogtekst1', class: 'nowrap', tooltip: true, selected: true },
  { key: 'Objekt3', default: '-', name: 'Beskrivelse', sortKey: 'Objekt__Objekt3', class: 'nowrap', tooltip: true, selected: true },
  { key: 'Salgspris', default: '', name: 'Tilslag', sortKey: 'Objekt__Salgspris', class: 'align-left', filter: 'integer', selected: true },

  { key: 'innlevav.Kundenr', default: '-', name: 'Selger #', sortKey: 'Innlevav__Kundenr', class: '', selected: true },
  { key: 'innlevav.parsed_name', default: '-', name: 'Selger', sortKey: '', class: 'unsortable', selected: true },
  { key: 'seller_invoice_addr.Postnr', default: '-', name: 'Selger postnr.', sortKey: 'seller_invoice_addr__Postnr', class: '', selected: true },
  { key: 'seller_country.Landbeskrivelse', default: '-', name: 'Selger land.', sortKey: 'seller_country__Landbeskrivelse', class: '', selected: true },

  { key: 'mottaker.Kundenr', default: '-', name: 'Kjøper #', sortKey: 'Mottaker__Kundenr', class: '', selected: true },
  { key: 'mottaker.parsed_name', default: '-', name: 'Kjøper', sortKey: '', class: 'unsortable', selected: true },
  { key: 'mottaker.Mobil', default: '-', name: 'Kjøper mobil', sortKey: 'Mottaker__Mobil', class: '', selected: true },
  { key: 'buyer_invoice_addr.Postnr', default: '-', name: 'Kjøper postnr.', sortKey: 'buyer_invoice_addr__Postnr', class: '', selected: true },
  { key: 'buyer_country.Landbeskrivelse', default: '-', name: 'Kjøper land.', sortKey: 'buyer_country__Landbeskrivelse', class: '', selected: true },

  { key: 'Vurderingspris2', default: '', name: 'Lav', sortKey: 'Objekt__Vurderingspris2', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderingspris1', default: '', name: 'Høy', sortKey: 'Objekt__Vurderingspris1', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Minstepris', default: '', name: 'Minstepris', sortKey: 'Objekt__Minstepris', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Tilslagnr', default: '', name: 'Tilslagnr', sortKey: 'Objekt__Tilslagnr', class: 'align-left', selected: true },
  { key: 'Mfgs', default: '', name: 'Mfgs', sortKey: 'Objekt__Mfgs', class: 'align-left', selected: true },

  { key: 'Bet_dato', default: '-', name: 'Betalt', sortKey: 'Objekt__Bet_dato', class: '', filter: 'date', selected: true },
  { key: 'Lev_dato', default: '-', name: 'Utlevert', sortKey: 'Objekt__Lev_dato', class: '', filter: 'date', selected: true },

  { key: 'Salar', default: '', name: 'Salar %', sortKey: 'Objekt__Salar', class: 'align-left', filter: 'decimal', selected: true },
  { key: 'Salarbelop', default: '', name: 'Salarbeløp', sortKey: 'Objekt__Salarbelop', class: 'unsortable align-left', filter: 'decimal', selected: true },

  { key: 'Fakturadato', default: '-', name: 'Fakturadato', sortKey: 'Objekt__Fakturadato', class: '', filter: 'date', selected: true },
  { key: 'Lagerleiedato', default: '-', name: 'Lagerleie start dato', sortKey: 'Objekt__Lagerleiedato', class: 'align-left', filter: 'date', selected: true },
  { key: 'Lagerleiesum', default: '', name: 'Lagerleie sum', sortKey: '', class: 'unsortable align-left', filter: 'decimal', selected: true },
  { key: 'lokasjon.Lokasjonkode', default: '-', name: 'Lokasjon', sortKey: 'Lokasjon__Lokasjonkode', class: '', selected: true },
  // { key: 'oppgjor_dato', default: '-', name: 'Oppgjørsdato', sortKey: '', class: 'unsortable', filter: 'date', selected: true },
  // { key: 'oppgjor_belop', default: '', name: 'Oppgjørsbelop', sortKey: '', class: 'unsortable', filter: 'decimal', selected: true },
  { key: 'Registrert_dato', default: '-', name: 'Registrert', sortKey: 'Objekt__Registrert_dato', class: 'sorttable_numeric', filter: 'datetime', selected: true },
  { key: 'kontrakt.Mottaker', default: '-', name: 'Kontraktsansvarlig', sortKey: 'kontrakt__Mottaker', class: '', selected: true },

  { key: 'Auksjon', default: '-', name: 'Auksjon', sortKey: 'Objekt__Auksjon', class: '', selected: false },
  { key: 'Auksjonsdato', default: '-', name: 'Auksjonsdato', sortKey: 'na_max_slutt', class: '', filter: 'date', selected: false },
  { key: 'current_nett_bud', default: '-', name: 'Nettbud belop', sortKey: '', class: 'unsortable', filter: 'integer', selected: false },
  { key: 'current_belopbud', default: '-', name: 'Antall bud', sortKey: '', class: 'unsortable', filter: 'integer', selected: false },
  { key: 'current_budgivere', default: '-', name: 'Antall budgivere', sortKey: '', class: 'unsortable', filter: 'integer', selected: false },
  { key: 'avdeling.Beskrivelse', default: '-', name: 'Avdeling', sortKey: 'Avdeling__Beskrivelse', class: '', selected: false },
  { key: 'Objekttype', default: '-', name: 'Type', sortKey: 'Objekt__Objekttype', class: '', selected: false },
  { key: 'Katalogtekst2', default: '-', name: 'Tekst', sortKey: 'Objekt__Katalogtekst2', class: 'unsortable nowrap', tooltip: true, selected: false },
  { key: 'Objekt1', default: '-', name: 'Signert', sortKey: 'Objekt__Objekt1', class: 'nowrap', tooltip: true, selected: false },
  { key: 'Tekst_ok', default: '', name: 'Objekt', sortKey: 'Objekt__Tekst_ok', class: '', selected: false },
  { key: 'Fototatt', default: '', name: 'Foto', sortKey: 'Objekt__Fototatt', class: '', selected: false },
  { key: 'kontrakt.Registrertsignert', default: '', name: 'Kontrakt', sortKey: 'kontrakt__Registrertsignert', class: '', filter: 'boolean', selected: false },
  { key: 'Fakturert', default: '', name: 'Fakturert', sortKey: 'Objekt__Fakturert', class: '', selected: false },
  { key: 'SalarKjoper', default: '0', name: 'Kjøper salær', sortKey: '', class: '', filter: 'integer', selected: false },
  { key: 'SalarSelger', default: '0', name: 'Selger salær', sortKey: '', class: '', filter: 'integer', selected: false },
  { key: 'SalarTotal', default: '0', name: 'Sum inntekt', sortKey: '', class: '', filter: 'integer', selected: false }
]

const DEFAULT_IMAGE_SIZES = [
  { key: 'c-image-none', name: 'Ingen bilder', selected: false },
  { key: 'c-image-small', name: 'Små bilder', selected: true },
  { key: 'c-image-medium', name: 'Mellomstore bilder', selected: false },
  { key: 'c-image-large', name: 'Store bilder', selected: false }
]

const LS_KEY = 'tilslagsliste-search-values'
const LS_KEY_COLS = 'columns'
const LS_KEY_IMAGE_SIZES = 'imagesizes'

const state = {
  defaultColumns: null,
  defaultImageSizes: null
}

const validationLS = (key) => {
  let retval = loadLs(key) || null
  let validationKey = 'ls-token-' + key
  let validationValue = localStorage.getItem(validationKey) || null

  let defaultCols = []
  if (key === LS_KEY_COLS) {
    defaultCols = DEFAULT_COLUMNS
  } else if (key === LS_KEY_IMAGE_SIZES) {
    defaultCols = DEFAULT_IMAGE_SIZES
  }

  if (retval) {
    let lsToken = md5(JSON.stringify(defaultCols))

    if (validationValue && lsToken === validationValue) {
      console.log('The ' + key + ' has a valid token.')
    } else {
      saveLs(key, defaultCols)
      localStorage.setItem(validationKey, lsToken)
      console.log('The ' + key + ' has a new token: ' + lsToken)
    }
  }
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  columns: state => {
    validationLS(LS_KEY_COLS)

    if (!state.defaultColumns) {
      let retval = loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS

      // How we get possibly new cols added...
      if (retval !== DEFAULT_COLUMNS) {
        retval = _.uniqBy([...retval, ...DEFAULT_COLUMNS], 'key')
      }

      return retval
    }

    return state.defaultColumns
  },
  imagesizes: state => {
    validationLS(LS_KEY_IMAGE_SIZES)

    if (!state.defaultImageSizes) {
      return loadLs(LS_KEY_IMAGE_SIZES) || DEFAULT_IMAGE_SIZES
    }

    return state.defaultImageSizes
  },
  selectedImageSize: (state, getters) => {
    return getters.imagesizes.find(i => i.selected === true)
  }
}

const actions = {
  saveImageSizes: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveImageSizes', payload)
      resolve()
    })
  },
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  }
}

const mutations = {
  'saveImageSizes': (state, payload) => {
    state.defaultImageSizes = payload
    saveLs(LS_KEY_IMAGE_SIZES, payload)
  },
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tilslagsskjermbilde.js